// config
export const SET_MOBILE = 'SET_MOBILE'
export const SET_NAVBAR = 'SET_NAVBAR'

// auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const USERINFO_SUCCESS = 'USERINFO_SUCCESS'
export const USERINFO_FAILURE = 'USERINFO_FAILURE'
export const LOGOUT_USER = 'LOGOUT_USER'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'

// notification
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const UNLOCK_NOTIFICATION = 'UNLOCK_NOTIFICATION'
export const ADD_LOADING_BTN = 'ADD_LOADING_BTN'
export const REMOVE_LOADING_BTN = 'REMOVE_LOADING_BTN'

// events
export const ADD_EVENT = 'ADD_EVENT'
export const UNLOCK_EVENT = 'UNLOCK_EVENT'

// coaches
export const COACH_LIST = 'COACH_LIST'
export const GET_COACH_DATA = 'GET_COACH_DATA'
export const MENU_LIST = 'MENU_LIST'

// slides
export const SLIDE_LIST = 'SLIDE_LIST'

// users
export const USER_LIST = 'USER_LIST'

// panoramas
export const GET_PANORAMA_DATA = 'GET_PANORAMA_DATA'
export const GET_EXTERIOR_DATA = 'GET_EXTERIOR_DATA'

// general
export const ACTIVATE_SCROLL = 'ACTIVATE_SCROLL'
export const DEACTIVATE_SCROLL = 'DEACTIVATE_SCROLL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js